<div class="calibration-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">
            <mat-icon>straighten</mat-icon>
            {{'viewer.calibration.image' | translate}}
        </h2>

        <span class="spacer"></span>

        <lib-button (click)="cancelCalibration()" icon="close" color="none" textColor="muted"
            tooltip="{{'form.close'|translate}}">
        </lib-button>
    </div>

    <!-- Canvas Container -->
    <div class="width-full">
        <div class="canvas-container">
            <div id="calibration-map-container" #calibrationMapContainer class="map-container">
                <p class="info-text" *ngIf="!calibrationMode()">
                    {{'viewer.calibration.loading' | translate}}
                </p>
            </div>

            <!-- Info Box -->
            <div class="info-box">
                <div class="info-item">
                    <span class="label">Mode:</span>
                    <span class="value">{{ 'viewer.calibration.mode.' + calibrationMode() | translate }}</span>
                </div>

                @if (calibrationError()) {
                <div class="error-message">
                    <mat-icon>warning</mat-icon>
                    <span>{{ getErrorMessage(calibrationError()) }}</span>
                </div>
                }

                @if (calibrationPoint1()) {
                <div class="info-item info-point">
                    <div class="point-info">
                        <span class="label">Point 1:</span>

                        <span class="value">
                            x:{{ calibrationPoint1().pixel.x | number:'1.0-0' }},
                            y:{{ calibrationPoint1().pixel.y | number:'1.0-0' }}
                        </span>
                    </div>

                    @if (calibrationMode() === 'editing-point1') {
                    <lib-button color="none" textColor="secondary" icon="my_location"></lib-button>
                    } @else {
                    <lib-button (click)="onEditPoint('point1')" icon="edit" color="none" textColor="muted">
                    </lib-button>
                    }
                </div>
                }

                @if (calibrationPoint2()) {
                <div class="info-item info-point">
                    <div class="point-info">
                        <span class="label">Point 2:</span>

                        <span class="value">
                            x:{{ calibrationPoint2().pixel.x | number:'1.0-0' }},
                            y:{{ calibrationPoint2().pixel.y | number:'1.0-0' }}
                        </span>
                    </div>

                    @if (calibrationMode() === 'editing-point2') {
                    <lib-button color="none" textColor="secondary" icon="my_location"></lib-button>
                    } @else {
                    <lib-button (click)="onEditPoint('point2')" icon="edit" color="none" textColor="muted">
                    </lib-button>
                    }
                </div>
                }
            </div>
        </div>
    </div>

    <!-- Forms Section -->
    @if (calibrationMode() === 'edit-coords' && calibrationPoint1() && calibrationPoint2()) {
    <mat-card class="forms-section">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>place</mat-icon>
                {{'viewer.calibration.coordinates' | translate}}
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="form-row">
                <!-- Point 1 Form -->
                <form [formGroup]="point1Form" class="point-form">
                    <h3>
                        <mat-icon>place</mat-icon>
                        Point 1
                    </h3>

                    <div class="row">
                        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
                            <mat-label>Latitude</mat-label>
                            <input matInput type="number" formControlName="lat" step="0.0001" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
                            <mat-label>Longitude</mat-label>
                            <input matInput type="number" formControlName="lon" step="0.0001" />
                        </mat-form-field>
                    </div>
                </form>

                <!-- Point 2 Form -->
                <form [formGroup]="point2Form" class="point-form">
                    <h3>
                        <mat-icon>place</mat-icon>
                        Point 2
                    </h3>

                    <div class="row">
                        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
                            <mat-label>Latitude</mat-label>
                            <input matInput type="number" formControlName="lat" step="0.0001" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
                            <mat-label>Longitude</mat-label>
                            <input matInput type="number" formControlName="lon" step="0.0001" />
                        </mat-form-field>
                    </div>
                </form>
            </div>

            <!-- Bouton Calculate -->
            @if (point1Form.valid && point2Form.valid) {
            <div class="calculate-button-container">
                <lib-button (click)="onCalculate()" icon="calculate" color="primary"
                    text="{{'viewer.calibration.calculate' | translate}}">
                </lib-button>
            </div>
            }
        </mat-card-content>
    </mat-card>
    }

    <!-- Preview Results -->
    @if (calibrationMode() === 'preview' && calibrationPreview()) {
    <mat-card class="preview-section">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>preview</mat-icon>
                {{'viewer.calibration.preview' | translate}}
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="result-grid">
                <!-- North -->
                <div class="result-item">
                    <mat-icon class="result-icon">arrow_upward</mat-icon>
                    <div class="result-content">
                        <span class="label">{{'geometry.north' | translate}}:</span>
                        <span class="value">{{ calibrationPreview().mapCoord.north.toFixed(5) }}</span>
                    </div>
                </div>

                <!-- South -->
                <div class="result-item">
                    <mat-icon class="result-icon">arrow_downward</mat-icon>
                    <div class="result-content">
                        <span class="label">{{'geometry.south' | translate}}:</span>
                        <span class="value">{{ calibrationPreview().mapCoord.south.toFixed(5) }}</span>
                    </div>
                </div>

                <!-- East -->
                <div class="result-item">
                    <mat-icon class="result-icon">arrow_forward</mat-icon>
                    <div class="result-content">
                        <span class="label">{{'geometry.east' | translate}}:</span>
                        <span class="value">{{ calibrationPreview().mapCoord.east.toFixed(5) }}</span>
                    </div>
                </div>

                <!-- West -->
                <div class="result-item">
                    <mat-icon class="result-icon">arrow_back</mat-icon>
                    <div class="result-content">
                        <span class="label">{{'geometry.west' | translate}}:</span>
                        <span class="value">{{ calibrationPreview().mapCoord.west.toFixed(5) }}</span>
                    </div>
                </div>

                <!-- Scale -->
                <div class="result-item">
                    <mat-icon class="result-icon">straighten</mat-icon>
                    <div class="result-content">
                        <span class="label">{{'viewer.calibration.scale' | translate}}:</span>
                        <span class="value">{{ calibrationPreview().scale.toFixed(4) }} m/px</span>
                    </div>
                </div>

                <!-- Angle -->
                <div class="result-item">
                    <mat-icon class="result-icon">rotate_right</mat-icon>
                    <div class="result-content">
                        <span class="label">Angle:</span>
                        <span class="value">{{ calibrationPreview().angle.toFixed(2) }}°</span>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    }

    <!-- Action Buttons -->
    <!-- <div class="action-buttons">
        <lib-button (click)="cancelCalibration()" icon="close" color="outline" text="{{'form.cancel' | translate}}">
        </lib-button>
    </div> -->
</div>